import React from 'react';
import styles from './Finish.module.css';
import ButtonAlt from '../components/ButtonAlt';
import * as constants from '.././constants';

const Finish = (props) => {

    let teams = JSON.parse(JSON.stringify(props.teams));
    // sort teams by score
    teams.sort((t1, t2) =>
        (t1.score > t2.score) ? -1 : ((t2.score > t1.score) ? 1 : 0));
    // generate scoreTable
    const maxScore = teams[0].score;
    let winners = 0;

    const scoreTable = teams.map(t => {
        if (t.score === maxScore) {
            winners++;
            return (
                <div key={t.id} className={[styles.team, styles.winner].join(' ')}>
                    <div className={[styles[t.id], styles.teamName].join(' ')}>{t.name}</div>
                    <div className={styles.teamScore}>{t.score}</div>
                </div>
            );
        }
        else {
            return (
                <div key={t.id} className={styles.team}>
                    <div className={[styles[t.id], styles.teamName].join(' ')}>{t.name}</div>
                    <div className={styles.teamScore}>{t.score}</div>
                </div>
            );
        }
    });
    
    let title = constants.TEXT13;
    if (winners > 1) title = constants.TEXT15;

    return (
        <div className={styles.container}>
            <div className={styles.scoreTable}>
                <div className={styles.title}>{title}</div>
                {scoreTable}
            </div>
            <div className={styles.buttons}>
                <ButtonAlt onClick={props.resetGame}>{constants.TEXT20}</ButtonAlt>
            </div>
        </div>
    );
}

export default Finish;